function goingEvent(c, e, a) {
    //ie9才支持addEventListener
    if (c.addEventListener) {
        c.addEventListener(e, a, false);
    }
    else {
        //ie8 支持attachEvent
        if (c.attachEvent) {
            c.attachEvent("on" + e, a);
        }
    }
}
goingEvent.touchDelay = 2000;
goingEvent.initTouch = function () {
    var g;
    var h;
    var c, a;
    goingEvent(document.body, "touchstart", function (l) {
        h = l.touches[0].target;
        c = l.touches[0].clientX;
        a = l.touches[0].clientY;
        g = window.setTimeout(e, goingEvent.touchDelay);
    });
    function e() {
        if (h) {
            // 创建事件.不支持ie8 哦
            var l = document.createEvent("HTMLEvents");
            // 初始化一个点击事件，可以冒泡，可以被取消
            l.initEvent("dblclick", true, true);
            // 触发事件监听
            h.dispatchEvent(l);
            g = h = null;
        }
    }
    goingEvent(document.body, "touchmove", function (l) {
        if (g) {
            if (Math.abs(l.touches[0].clientX - c) > 50 ||
                Math.abs(l.touches[0].clientY - a) > 50) {
                window.clearTimeout(g);
                g = h = false;
            }
        }
    });
    goingEvent(document.body, "touchend", function (l) {
        if (g) {
            window.clearTimeout(g);
            g = h = false;
        }
    });
    goingEvent.initTouch = function () { };
};

export default goingEvent;



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/global/goingEvent.js